"use client";

import { useLingui } from "@lingui/react/macro";
import { AuthCardLayout } from "~/components/auth/AuthCardLayout";
import { SignUpFormContent, type SignUpFormProps } from "./SignUpFormContent";

export const SignUpForm = (props: SignUpFormProps) => {
	const { t } = useLingui();
	return (
		<AuthCardLayout title={t`Create Account`}>
			<SignUpFormContent {...props} />
		</AuthCardLayout>
	);
};
